module.exports = __webpack_public_path__ + "img/sld_ch_12_t1_green.318a15f5.svg";